export class ReceivedMailController {
  constructor($rootScope, $scope, $interval, $timeout, $sce, socket, UserService, LikeService, LockService, ChatService, toastr) {
    this.rootScope = $rootScope;
    this.scope = $scope;
    this.interval = $interval;
    this.timeout = $timeout;
    this.sce = $sce;
    this.socket = socket;
    this.ChatService = ChatService;
    this.LikeService = LikeService;
    this.LockService = LockService;
    this.UserService = UserService;
    this.toastr = toastr;

    this.scope.$on('open_chat_list', (e, userId) => this.init(userId));
    this.scope.$on('update_chat', (e, chat_room) => this.onUpdateChat(chat_room));
    this.scope.$on('refresh_chat', (e) => {
      if(this.scope.activeChatAccordion.room_id) {
        let json_data = JSON.stringify({chat_room: this.scope.activeChatAccordion.room_id});
        this.socket.emit('connect_user', json_data)
      }
    });

    this.socket.on('changedUserOnlineStatus', (json_data) => {
      if(this.rootScope.chat_panel) {
        let data = JSON.parse(json_data);
        this.onChangeUserOnlineStatus(data);
      }
    });

    this.socket.on('message', (data) => {
      if(this.scope.activeChatAccordion.isLoad) {
        this.onMessage(data);
      }
    });

    this.socket.on('updateIsRead', (json_data) => {
      if(this.scope.activeChatAccordion.isLoad) {
        let data = JSON.parse(json_data);
        this.updateIsRead(data.messages);
      }
    });
  }

  init(userId) {
    this.writeToUserID = userId;
    this.scope.chatList = [];
    this.scope.waitForChatList = false;
    this.scope.activeChat = [];
    this.scope.activeChatAccordion = {};
    this.scope.hasNewMessage = [];
    this.scope.lock = [];
    this.scope.lockMessage = 'Debes tener una cuenta VIP para poder ver este mensaje <a href="/homerd/centrodepago/">cuenta VIP</a>.';
    this.scope.lockProfileMess = 'Debes tener una <a href="/homerd/centrodepago/">Cuenta VIP</a><br> para poder ver este mensaje';

    this.scope.pagination = {
      page: 1,
      limit: 12
    };

    this.scope.getChatList = () => {
      if(!this.scope.waitForChatList) {
        this.scope.waitForChatList = true;
        this.getChatList();
      }
    };

    this.scope.sendMessage = (message, chat) => {
      this.sendMessage(message, chat);
    };

    this.scope.loadChatRoom = (chat_room, page, limit) => {
      this.loadChatRoom(chat_room, page, limit);
    };

    this.scope.leaveChatRoom = (chat_room) => {
      this.leaveChatRoom(chat_room);
    };

    this.scope.removeChatList = () => {
      this.removeChatList();
    };

    this.scope.getAvatar = (user, isOwnPage, size = '') => {
      return this.UserService.getAvatar(user, isOwnPage, size);
    };

    this.UserService.getCurrentUser()
      .then((response) => { let user = response.data;
        this.rootScope.currentUserProfile = user.data;
        this.scope.getChatList(1);
      })
      .catch((response) => { let err = response.data;
        console.error(err);
      });
  }

  getChatList() {
    this.ChatService.getChatList(this.scope.pagination.page, this.scope.pagination.limit)
    .then((response) => { let data = response.data;
      let chatList = data.chatList;
      for(let i in chatList) {
        let chat = chatList[i];
        if((chat.sender && chat.sender._id === this.rootScope.currentUserProfile._id && chat.sender_status === 1)
            || (chat.receiver && chat.receiver._id === this.rootScope.currentUserProfile._id && chat.receiver_status === 1)) {
          this.scope.hasNewMessage[chat.name] = true;
        }
        this.lockChat(chat);
      }

      this.scope.chatList = this.scope.chatList.concat(chatList);
      this.scope.chatList = _.uniqBy(this.scope.chatList, item => item._id);
      this.scope.pagination.totalPages = data.pageCount;

      if (chatList.length) {
        this.scope.pagination.page++;
      }

      if(this.writeToUserID) {
        this.onOpenChat(this.writeToUserID);
        this.writeToUserID = undefined;
      }

      this.scope.waitForChatList = false;
    })
    .catch((response) => { let err = response.data;
      this.scope.waitForChatList = false;
      console.error(err);
    })
  }

  sendMessage(msg, chat) {
    if (!msg) {
      return;
    }

    if (this.rootScope.currentUserProfile.status === 0) {
      this.toastr.warning('Su perfil es desactivado, no se puede hacer esto.');
      return;
    }

    if(!this.socket.isConnected()) {
      this.toastr.error('La conexión con el servidor se perdió');
      return;
    }

    if (this.scope.activeChat
      && this.scope.activeChat.length
      && this.scope.activeChat[this.scope.activeChat.length - 1].can_reply === false
      && this.scope.activeChat[this.scope.activeChat.length - 1].sender._id !== this.rootScope.currentUserProfile._id) {
        this.toastr.warning("No puede responder este mensaje");
       return;
    }

    // sender - person who has initiated chat
    let interlocutor = (chat.receiver._id === this.rootScope.currentUserProfile._id) ? chat.sender : chat.receiver;

    this.LockService.isBlocked(interlocutor._id, this.rootScope.currentUserProfile._id)
      .then((response) => { let isBlocked = response.data;
        if (isBlocked.success) {
          this.toastr.error('Has sido bloqueado por este usuario');
          return;
        }

        this.LikeService.isMutualLiked(interlocutor._id, this.rootScope.currentUserProfile._id)
          .then((response) => { let resultMutual = response.data;
            if (resultMutual.data) {
              var isMutual = resultMutual.data;
            }

            if (!isMutual && interlocutor.filters && interlocutor.filters.matchfilters) {
              let nowDate = new Date();
              let year = nowDate.getFullYear();
              let minBirthdate = new Date();
              let maxBirthdate = new Date();

              minBirthdate.setFullYear(year - interlocutor.filters.minage);
              minBirthdate = minBirthdate.toISOString();
              maxBirthdate.setFullYear(year - interlocutor.filters.maxage);
              maxBirthdate = maxBirthdate.toISOString();

              if (interlocutor.filters.region && interlocutor.filters.region._id !== this.rootScope.currentUserProfile.region) {
                this.toastr.error('No puedes comunicarte con esta personas porque no cumples con sus “<a href="/profilerd/profile/id/' + interlocutor._id + '">filtros de contacto</a>”.');
                return;
              }

              if (!(maxBirthdate < this.rootScope.currentUserProfile.birthday && minBirthdate > this.rootScope.currentUserProfile.birthday)) {
                this.toastr.error('Edad no coincide');
                return;
              }

              if (interlocutor.filters.photorequired && (!this.rootScope.currentUserProfile.photoprofile.approved && !this.rootScope.currentUserProfile.photoprofile.url)) {
                this.toastr.error('Foto obligado a ponerse en contacto con');
                return;
              }
          }

          let json_data = JSON.stringify({
            receiver: interlocutor._id,
            sender: this.rootScope.currentUserProfile._id,
            chat_room: chat.chat_room,
            msg: msg.text
          });

          this.socket.emit('message', json_data);
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        })
      })
      .catch((response) => { let err = response.data;
        console.error(err);
      })
  }

  onMessage(json_data) {
    let data = JSON.parse(json_data),
        chat_room = data.chatRoom,
        message = data.message;

    message.message = message.message.replace(/\n/g, "<br>");
    this.scope.activeChat.push(message);
    this.scope.activeChat = _.uniqBy(this.scope.activeChat, item => item._id);
    if(this.scope.activeChat.length > 10) this.scope.activeChat.shift();
    this.scrollIntoBottom(chat_room);
    if(!this.scope.lock[chat_room] && !message.isRead && message.sender._id !== this.rootScope.currentUserProfile._id) {
      this.socket.emit('read', JSON.stringify({chat_room: data.chatRoom, messageIDs: [message._id]}));
    }
  }

  updateIsRead (messages) {
    for (let i in this.scope.activeChat) {
      for (let j = 0; j < messages.length; j++) {
        if (this.scope.activeChat[i]._id === messages[j]) {
          this.scope.activeChat[i].isRead = true;
        }
      }
    }
  };

  onOpenChat(userId) {
    if(userId) {
      let chat_room = this.getRoomName(userId, this.rootScope.currentUserProfile._id);
      let foundChat = _.find(this.scope.chatList, chat => chat.name === chat_room);

      if(foundChat) {
        _.remove(this.scope.chatList, chat => chat.name === chat_room);
        this.scope.chatList.unshift(foundChat);
        this.scope.chatList = _.uniqBy(this.scope.chatList, item => item._id);
        this.toggleChat(chat_room);
      } else {
        this.UserService.getUserProfile(userId)
          .then((response) => { let user = response.data;
            let chat = {
              name: chat_room,
              sender: this.rootScope.currentUserProfile,
              sender_status: 2,
              receiver: user.data,
              receiver_status: 1,
              created_at: new Date(),
              updated_at: new Date()
            };

            //this.lockChat(chat);
            this.scope.chatList.unshift(chat);
            this.scope.chatList = _.uniqBy(this.scope.chatList, item => item._id);
            this.toggleChat(chat_room);
          })
          .catch((response) => { let err = response.data;
            console.error(err);
          });
      }
    }
  }

  onUpdateChat(chat_room) {
    if(this.scope.activeChatAccordion.room_id === chat_room) {
      return;
    }

    if(!_.find(this.scope.chatList, chat => chat.name === chat_room)) {
      this.ChatService.getChat(chat_room)
        .then((response) => { let data = response.data;
          let chat = data.data;

          if(chat) {
            //this.lockChat(chat);
            if(chat.sender._id === this.rootScope.currentUserProfile._id && chat.sender_status === 1 || chat.receiver._id === this.rootScope.currentUserProfile._id && chat.receiver_status === 1) {
              this.scope.hasNewMessage[chat.name] = true;
            }

            // if(this.scope.activeChatAccordion.room_id && _.findIndex(this.scope.chatList, (obj) => obj.name === this.scope.activeChatAccordion.room_id) === 0) {
            //   this.scope.chatList.splice(1, 0, chat);
            // } else {
              this.scope.chatList.unshift(chat);
              this.scope.chatList = _.uniqBy(this.scope.chatList, item => item._id);
            // }
          }
        })
        .catch((response) => { let err = response.data;
          console.error(err);
        });
    } else {
      this.scope.hasNewMessage[chat_room] = true;
    }
  }

  onChangeUserOnlineStatus(data) {
    _.forEach(this.scope.chatList, (chat) => {
      if (chat.sender._id === data.id) {
        chat.sender.isOnline = data.isOnline;
      }

      if (chat.receiver._id === data.id) {
        chat.receiver.isOnline = data.isOnline;
      }
    })
  }

  toggleChat (id) {
    this.timeout(() => {
      $('a[accordion-toggle="'+ id +'"]').click();
    });
  }

  scrollIntoBottom (chat_room) {
    if(!this.scope.activeChat.length) return;
    // Scroll to bottom if has more than one message
    if ($('.content#'+chat_room+' .chatBoxHeight > div').length > 1) {
      $('.content#'+chat_room+' .chatBox').animate({
        scrollTop: $('.content#'+chat_room+' .chatBoxHeight').height()
      }, () => {
        this.scope.activeChatOptions.active = this.scope.activeChatOptions.page != this.scope.activeChatOptions.totalPages;
        this.scope.activeChatOptions.topMessageId = this.scope.activeChat[0]._id;
      });
    }
  }

  loadChatRoom(chat_room, page, limit) {
    if(this.scope.activeChatOptions && this.scope.activeChatOptions.active === false) return;

    if(!page) page = 1;
    if(!limit) limit = 10;

    let json_data = JSON.stringify({chat_room: chat_room});
    this.socket.emit('connect_user', json_data);
    if(page == 1) {
      this.scope.activeChat = [];
      this.scope.notReadMsgIDs = [];
    }
    this.scope.$apply();

    this.scope.activeChatOptions = {
      chat_room: chat_room,
      page: page,
      limit: limit,
      active: false,
      totalPages: this.scope.activeChatOptions ? this.scope.activeChatOptions.totalPages : null,
      topMessageId: this.scope.activeChatOptions ? this.scope.activeChatOptions.topMessageId : null
    };

    this.ChatService.getMessages(chat_room, page, limit)
      .then((response) => { let data = response.data;
        if(page == 1) {
          var messages = [];
          var notReadMsgIDs = [];
        } else {
          messages = this.scope.activeChat;
          notReadMsgIDs = this.scope.notReadMsgIDs;
        }
        this.scope.activeChatOptions.totalPages = data.pageCount;

        if(!this.scope.lock[chat_room]) {
          this.scope.hasNewMessage[chat_room] = false;
        }

        for(let i in data.messages) {
          let message = data.messages[i];
          message.message = message.message.replace(/\n/g, "<br>");

          if (!this.scope.lock[chat_room] && message.receiver._id === this.rootScope.currentUserProfile._id && !message.isRead) {
            notReadMsgIDs.push(message._id);
          }

          messages.unshift(message);
        }

        if(page > 1) {
          let elm = document.getElementById(`${chat_room}`);
          elm = elm.getElementsByClassName('chatBox')[0];
          this.scope.scrollPosition = {
            node: elm,
            previousScrollHeightMinusTop: parseInt(elm.scrollHeight) - parseInt(elm.scrollTop)
          };
        }

        this.scope.messages = _.uniqBy(this.scope.messages, item => item._id);
        this.scope.activeChat = messages;

        if(!this.scope.lock[chat_room]) {
          this.socket.emit('read', JSON.stringify({chat_room: chat_room, messageIDs: notReadMsgIDs}));
        }

        this.scope.notReadMsgIDs = notReadMsgIDs;

        this.timeout(() => {
          if (page > 1) {
            if(!this.scope.activeChat[0]._id) return;

            this.scope.scrollPosition.node.scrollTop = parseInt(this.scope.scrollPosition.node.scrollHeight) -
              this.scope.scrollPosition.previousScrollHeightMinusTop;

            this.scope.activeChatOptions.active = this.scope.activeChatOptions.page != this.scope.activeChatOptions.totalPages;
            this.scope.activeChatOptions.topMessageId = this.scope.activeChat[0]._id;
          } else {
            this.scrollIntoBottom(chat_room);
          }
        });
      })
      .catch((response) => { let err = response.data;
        console.error(err);
      })
  }

  leaveChatRoom() {
    this.socket.emit('disconnect_user');
    this.scope.activeChat = [];
    this.scope.$apply();
  }

  removeChatList() {
    let list = [];
    if(this.scope.activeChatAccordion.room_id) {
      this.toggleChat(this.scope.activeChatAccordion.room_id);
    }
    //search checked chats
    _.forEach(this.scope.chatList, (chat) => {
      if(chat.flag) {
        list.push(chat.name);
        this.scope.hasNewMessage[chat.name] = false;
      }
    });

    if(list.length > 0) {
      if (confirm('¿Seguro que quiere eliminar el mensaje?')) {
        this.ChatService.removeChatList(list)
          .then((response) => { let res = response.data;
            for(let chat of list) {
              _.remove(this.scope.chatList, item => item.name === chat);
            }

            this.socket.emit('countMsgs', JSON.stringify({userId: this.rootScope.currentUserProfile._id}));
            this.socket.emit('disconnect_user');
          })
          .catch((response) => { let err = response.data;
            console.error(err);
            this.socket.emit('disconnect_user');
          })
      }
    }
  }

  lockChat(chat) {
    if (this.rootScope.isVip() ||
        (this.rootScope.currentUserProfile._id !== chat.sender._id && chat.sender.permanent === true || chat.sender.status === 2) ||
        (this.rootScope.currentUserProfile._id !== chat.receiver._id && chat.receiver.permanent === true || chat.receiver.status === 2)) {

      this.scope.lock[chat.name] = false;
    } else {
      this.scope.lock[chat.name] = true;
    }
  }

  getRoomName(sender, receiver) {
    let interlocutors = [receiver, sender].sort();
    let roomName = 'room_' + interlocutors.join('_');
    return roomName;
  }
}
